import * as Sentry from '@sentry/react';
import env from '@/config/env';

if (env.CUSTOM_NODE_ENV === 'production') {
  Sentry.init({
    environment: 'production',
    dsn: env.SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      env.AUTH_API_URL,
      env.CLOUDERS_API_URL,
      env.ORDERS_API_URL,
      env.STORAGE_API_URL,
      env.ROUTES_API_URL,
      env.NEW_ROUTES_API_URL,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
